<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <path
    fill="currentcolor"
    fill-rule="evenodd"
    d="M16 5.5H0v-2h16zM16 12.5H0v-2h16z"
    clip-rule="evenodd"
  />
  <path fill="currentcolor" fill-rule="evenodd" d="M3 7V2h2v5zM11 14V9h2v5z" clip-rule="evenodd" />
</svg>
